<template>
  <div class="contentArea">
    <AgGrid />
  </div>
</template>

<script>
import AgGrid from "../elements/ag-grid-table/AgGridTable.vue";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      nowSlug: "getNowSlug",
      tabActive: "general/tabActive",
      page: "general/page"
    })
  },
  components: {
    AgGrid
  },

  mounted() {
    this.$store.dispatch("general/getAllCurriculum");
    this.$store.dispatch("general/push_pointer", "curriculum");
  }
};
</script>

<style lang="scss" scoped></style>
